import { SIDENAV_ACTION_TYPES } from "../../_constants";

const sidenavReducer = (state = false, action) => {
    switch (action.type) {
        case SIDENAV_ACTION_TYPES.TOGGLE:
            return !action.status;

        default:
            return state;
    }
}

export default sidenavReducer;
